module.exports = __webpack_public_path__ + "img/leaf.f925d098.svg";